import VerifyContent from "../../../../modules/Verify/VerifyContent";
import MobileSliderPagesWrapper from "../components/MobileSliderPagesWrapper";
import MobileSliderPagesHeader from "../components/MobileSliderPagesHeader";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function SlideMobileVerify(props) {
    const {getLangPath} = useLangContext();
    const verificationEmail = getLangPath('verify.email');
    const pageDescriptionHtml = getLangPath('verify.text_html', {email: verificationEmail});

    return <MobileSliderPagesWrapper>
        <MobileSliderPagesHeader>
            <h4 className="mb-0 text-center">
                {getLangPath('verify.title')}
            </h4>
        </MobileSliderPagesHeader>
        <p className="text-center" dangerouslySetInnerHTML={{__html: pageDescriptionHtml}}/>
        <VerifyContent/>
    </MobileSliderPagesWrapper>
}

export default SlideMobileVerify;
